/* eslint-disable react/destructuring-assignment */
import { Box, Button, Typography } from '@mui/material';

import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorMessage: '',
    };
  }

  componentDidMount() {
    window.onerror = (message, source, lineno, colno, error) => {
      if (error?._ignoreError) return;

      this.setState({
        hasError: true,
        errorMessage: message || 'An unknown error occurred',
      });
      console.error(
        'Global error caught:',
        message,
        source,
        lineno,
        colno,
        error,
      );
    };
  }

  componentDidCatch(error, errorInfo) {
    if (error?._ignoreError) return;

    console.error('Error caught in ErrorBoundary:', error, errorInfo);
    this.setState({
      hasError: true,
      errorMessage: error.message,
    });
  }

  componentWillUnmount() {
    window.onerror = null;
  }

  handleReset = () => {
    this.setState({ hasError: false, errorMessage: '' });
  };

  handleReload = () => {
    this.setState({ hasError: false, errorMessage: '' });
    window.location.reload(true);
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            bgcolor: 'background.paper',
            p: 3,
            borderRadius: 2,
            boxShadow: 3,
          }}
        >
          <Typography variant='h4' color='error'>
            Something went wrong!
          </Typography>
          <Typography variant='body1' sx={{ mt: 2 }}>
            {this.state.errorMessage}
          </Typography>
          <Box display='flex' gap={3}>
            <Button
              variant='contained'
              color='primary'
              onClick={this.handleReset}
              sx={{ mt: 3 }}
            >
              Dismiss
            </Button>
            <Button
              variant='contained'
              color='primary'
              onClick={this.handleReload}
              sx={{ mt: 3 }}
            >
              Try reload
            </Button>
          </Box>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
